<template>
  <ul class="pagination pagination-sm justify-content-center">
    <template
      v-for="(page, idx) of pages"
      :key="idx"
    >
      <li
        v-if="page.type == 'first'"
        :class="{ 'page-item': true, 'disabled': page.nr == null }"
      >
        <a
          class="page-link"
          href="#"
          @click.prevent="changePage(page)"
        >
          <span class="glyphicons paging-first" />
          First
        </a>
      </li>
      <li
        v-else-if="page.type == 'prev'"
        :class="{ 'page-item': true, 'disabled': page.nr == null }"
      >
        <a
          class="page-link"
          href="#"
          @click.prevent="changePage(page)"
        >
          <span class="glyphicons paging-prev" />
          Previous
        </a>
      </li>
      <li
        v-else-if="page.type == 'next'"
        :class="{ 'page-item': true, 'disabled': page.nr == null }"
      >
        <a
          class="page-link"
          href="#"
          @click.prevent="changePage(page)"
        >
          Next
          <span class="glyphicons paging-next" />
        </a>
      </li>
      <li
        v-else-if="page.type == 'last'"
        :class="{ 'page-item': true, 'disabled': page.nr == null }"
      >
        <a
          class="page-link"
          href="#"
          @click.prevent="changePage(page)"
        >
          Last
          <span class="glyphicons paging-last" />
        </a>
      </li>
      <li
        v-else-if="page.type == 'gap'"
        class="page-item disabled"
      >
        <a
          class="page-link"
          href="#"
          @click.prevent="changePage(null)"
        >
          ...
        </a>
      </li>
      <li
        v-else
        :class="{ 'page-item': true, 'active': page.current == true }"
      >
        <a
          class="page-link"
          href="#"
          @click.prevent="changePage(page)"
        >
          {{ page.nr }}
        </a>
      </li>
    </template>
  </ul>
</template>
<script setup lang="ts">

export interface GridPagerPage {
  type: 'first' | 'prev' | 'gap' | 'page' | 'next' | 'last';
  nr: number | null;
  current: boolean;
}

defineProps({
  pages: {default: null, type: Array as () => GridPagerPage[]},
  currentPage: {default: null, type: Number},
})

const emit = defineEmits<{
  (e: 'change-page', page: number): void
}>()

const changePage = (newPage: GridPagerPage | null): void => {
  if (newPage && newPage.nr) {
    emit('change-page', newPage.nr)
  }
}

</script>
